// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__1xFxo","Label":"BuildControl_Label__2DQ-V","Less":"BuildControl_Less__22ooG","More":"BuildControl_More__3Z-qN"};